export default {
  INFO_SNACKBAR (state) {
    return state.infoSnackbar
  },
  LOADING_SNACKBAR (state) {
    return state.loadingSnackbar
  },
  REPORT_SNACKBAR (state) {
    return state.reportSnackbar
  },
}
